import LoadingOverlay from "react-loading-overlay";

// Library bug: broken PropTypes for styles.content — not caused by missing props.
// https://github.com/derrickpelletier/react-loading-overlay/issues/56
LoadingOverlay.propTypes = undefined;

export default LoadingOverlay;
